import React from "react";
import { Grid, TextField, IconButton, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { isImage } from "../../../common/attachments/attachmentsHelper";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: theme.spacing(1, 0),
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: "flex",
        alignItems: "center",
        background: "transparent",
    },
    thumbnail: {
        height: 40,
        width: 40,
        borderRadius: 4,
        objectFit: "cover",
        background: "#f5f5f5",
        border: `1px solid ${theme.palette.divider}`,
    },
    fileNameBox: {
        marginLeft: theme.spacing(2),
        minWidth: 120,
        flex: 1,
    },
    extension: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontWeight: 500,
        minWidth: 40,
        alignSelf: "center",
    },
    commentBox: {
        marginLeft: theme.spacing(2),
        flex: 2,
        minWidth: 160,
    },
    deleteIcon: {
        marginLeft: theme.spacing(2),
        color: theme.palette.error.main,
    },
    editIcon: {
        marginRight: theme.spacing(1),
        verticalAlign: "middle",
        color: theme.palette.primary.main,
        fontSize: "1.1em",
    },
}));

const QuestionAttachmentList = ({ file, onChange, removeNewRow }) => {
    const classes = useStyles();
    const intl = useIntl();

    const thumbnailContent = isImage(file.fileType) ? (
        <img className={classes.thumbnail} src={`data:${file.fileType};base64,${file.data}`} alt={file.fileName} />
    ) : (
        <EditIcon className={classes.editIcon} />
    );

    const handleFileNameChange = (event) => {
        if (onChange) {
            const newFile = {
                ...file,
                fullFileName: event.target.value + "." + file.extension,
                fileName: event.target.value,
            };
            onChange(newFile);
        }
    };

    const handleFileDescriptionChange = (event) => {
        if (onChange) {
            onChange({ ...file, fileDescription: event.target.value });
        }
    };

    return (
        <Grid container className={classes.root} alignItems="center" wrap="nowrap" spacing={0}>
            <Grid item>{thumbnailContent}</Grid>
            <Grid item className={classes.fileNameBox}>
                <TextField
                    variant="outlined"
                    value={file.fileName}
                    error={!file.fileName?.trim()}
                    size="small"
                    InputProps={{
                        inputProps: { maxLength: 255 },
                    }}
                    onChange={handleFileNameChange}
                />
            </Grid>
            <Grid item className={classes.extension}>
                .{file.extension}
            </Grid>
            <Grid item className={classes.commentBox}>
                <TextField
                    variant="outlined"
                    value={file.fileDescription || ""}
                    placeholder={intl.formatMessage({ id: "activity.question.attachementDetails", defaultMessage: "Add comments here" })}
                    size="small"
                    multiline
                    fullWidth
                    minRows={1}
                    InputProps={{
                        inputProps: { maxLength: 300 },
                    }}
                    onChange={handleFileDescriptionChange}
                />
            </Grid>
            <Grid item>
                <IconButton className={classes.deleteIcon} onClick={() => removeNewRow(file.id)} aria-label="delete" size="small">
                    <DeleteIcon color="primary" />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default QuestionAttachmentList;
